/**
 * Part of starter project.
 *
 * @copyright  Copyright (C) 2021 LYRASOFT.
 * @license    __LICENSE__
 */

import u from '@main';

$(() => {
  const pageRenderContactAjax = u.route('page_render_contact_ajax');
  const contactLevel2Ajax = u.route('contact_level2_ajax');
  const level1Select = $('.js-contact-select-level1');
  const level2Select = $('.js-contact-select-level2');

  level1Select.on('change', async function () {
    const res = await u.$http.post(
      contactLevel2Ajax,
      {title: level1Select.val()}
    )
    level2Select.html(res.data.data.data);
    getAndRenderPage();
  })

  level2Select.on('change', async function () {
    getAndRenderPage();
  })

  async function getAndRenderPage()
  {
    const value = level2Select.val();
    const res = await u.$http.post(
      pageRenderContactAjax,
      {id: value}
    )

    $('.js-render-form-target').html(res.data.data.data);
  }
})
